import type { DaysByRow } from 'modules/shift_management/hooks/reducers/selection'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

import { NO_WORK_AREA } from '../store/internal/models/Shift'
import { useSelectionState } from './useSelection'

export type ShiftAttributes = {
  location_id: string | null
  work_area_id: string | null
}

export type ShiftsAttributesByDate = Record<string, ShiftAttributes[]>

const getDefaultAttributesFromWorkAreas = (daysByRow: DaysByRow): ShiftsAttributesByDate => {
  const result: ShiftsAttributesByDate = {}

  for (const rowId in daysByRow) {
    const dates = daysByRow[rowId]

    if (!dates) return {}

    const [locationId, workAreaId] = rowId.split('-')
    const location_id = locationId ? locationId : null
    const work_area_id = workAreaId && workAreaId != NO_WORK_AREA ? workAreaId : null

    dates.forEach((date: string) => {
      result[date] ||= []
      result[date]?.push({ location_id, work_area_id })
    })
  }

  return result
}

const useDefaultAttributesFromRows = (): ShiftsAttributesByDate => {
  const [{ view }] = useSchedule()
  const { isEnabled: hasSelection, daysByRow } = useSelectionState()

  if (!hasSelection) return {}

  if (view.isByAreas) {
    return getDefaultAttributesFromWorkAreas(daysByRow)
  }

  return {}
}

export default useDefaultAttributesFromRows
